function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var t = function t(_t) {
    return "object" == _typeof(_t) && null != _t && 1 === _t.nodeType;
  },
  e = function e(t, _e) {
    return (!_e || "hidden" !== t) && "visible" !== t && "clip" !== t;
  },
  n = function n(t, _n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
      var _o = getComputedStyle(t, null);
      return e(_o.overflowY, _n) || e(_o.overflowX, _n) || function (t) {
        var e = function (t) {
          if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
          try {
            return t.ownerDocument.defaultView.frameElement;
          } catch (t) {
            return null;
          }
        }(t);
        return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
      }(t);
    }
    return !1;
  },
  o = function o(t, e, n, _o2, l, r, i, s) {
    return r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - _o2 : i > e && s < n || r < t && s > n ? i - e + l : 0;
  },
  l = function l(t) {
    var e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
  },
  r = function r(e, _r2) {
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    var c = _r2.scrollMode,
      f = _r2.block,
      u = _r2.inline,
      a = _r2.boundary,
      g = _r2.skipOverflowHiddenElements,
      p = "function" == typeof a ? a : function (t) {
        return t !== a;
      };
    if (!t(e)) throw new TypeError("Invalid target");
    var m = document.scrollingElement || document.documentElement,
      w = [];
    var W = e;
    for (; t(W) && p(W);) {
      if (W = l(W), W === m) {
        w.push(W);
        break;
      }
      null != W && W === document.body && n(W) && !n(document.documentElement) || null != W && n(W, g) && w.push(W);
    }
    var b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth,
      H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight,
      _window = window,
      y = _window.scrollX,
      M = _window.scrollY,
      _e$getBoundingClientR = e.getBoundingClientRect(),
      v = _e$getBoundingClientR.height,
      E = _e$getBoundingClientR.width,
      x = _e$getBoundingClientR.top,
      C = _e$getBoundingClientR.right,
      I = _e$getBoundingClientR.bottom,
      R = _e$getBoundingClientR.left,
      _ref = function (t) {
        var e = window.getComputedStyle(t);
        return {
          top: parseFloat(e.scrollMarginTop) || 0,
          right: parseFloat(e.scrollMarginRight) || 0,
          bottom: parseFloat(e.scrollMarginBottom) || 0,
          left: parseFloat(e.scrollMarginLeft) || 0
        };
      }(e),
      T = _ref.top,
      B = _ref.right,
      F = _ref.bottom,
      V = _ref.left;
    var k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F,
      D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    var L = [];
    for (var _t2 = 0; _t2 < w.length; _t2++) {
      var _e2 = w[_t2],
        _e$getBoundingClientR2 = _e2.getBoundingClientRect(),
        _n2 = _e$getBoundingClientR2.height,
        _l = _e$getBoundingClientR2.width,
        _r = _e$getBoundingClientR2.top,
        _i = _e$getBoundingClientR2.right,
        _s = _e$getBoundingClientR2.bottom,
        _d = _e$getBoundingClientR2.left;
      if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= _r && I <= _s && R >= _d && C <= _i) return L;
      var _h = getComputedStyle(_e2),
        _a = parseInt(_h.borderLeftWidth, 10),
        _g = parseInt(_h.borderTopWidth, 10),
        _p = parseInt(_h.borderRightWidth, 10),
        _W = parseInt(_h.borderBottomWidth, 10);
      var _T = 0,
        _B = 0;
      var _F = "offsetWidth" in _e2 ? _e2.offsetWidth - _e2.clientWidth - _a - _p : 0,
        _V = "offsetHeight" in _e2 ? _e2.offsetHeight - _e2.clientHeight - _g - _W : 0,
        S = "offsetWidth" in _e2 ? 0 === _e2.offsetWidth ? 0 : _l / _e2.offsetWidth : 0,
        X = "offsetHeight" in _e2 ? 0 === _e2.offsetHeight ? 0 : _n2 / _e2.offsetHeight : 0;
      if (m === _e2) _T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? o(M, M + H, H, _g, _W, M + k, M + k + v, v) : k - H / 2, _B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : o(y, y + b, b, _a, _p, y + D, y + D + E, E), _T = Math.max(0, _T + M), _B = Math.max(0, _B + y);else {
        _T = "start" === f ? k - _r - _g : "end" === f ? k - _s + _W + _V : "nearest" === f ? o(_r, _s, _n2, _g, _W + _V, k, k + v, v) : k - (_r + _n2 / 2) + _V / 2, _B = "start" === u ? D - _d - _a : "center" === u ? D - (_d + _l / 2) + _F / 2 : "end" === u ? D - _i + _p + _F : o(_d, _i, _l, _a, _p + _F, D, D + E, E);
        var _t3 = _e2.scrollLeft,
          _h2 = _e2.scrollTop;
        _T = 0 === X ? 0 : Math.max(0, Math.min(_h2 + _T / X, _e2.scrollHeight - _n2 / X + _V)), _B = 0 === S ? 0 : Math.max(0, Math.min(_t3 + _B / S, _e2.scrollWidth - _l / S + _F)), k += _h2 - _T, D += _t3 - _B;
      }
      L.push({
        el: _e2,
        top: _T,
        left: _B
      });
    }
    return L;
  };
export { r as compute };